import React, { useEffect, useState } from "react";
import { Button, CircularProgress, Dialog, DialogContent, IconButton, Tooltip, Typography, } from "@mui/material";
import { CloseOutlined } from "@mui/icons-material";
import styled from "styled-components";
import { DataGrid } from "@mui/x-data-grid";
import DownloadIcon from '@mui/icons-material/Download';
import html2pdf from 'html2pdf.js';
import "./orderLineItemModal.css";
import LogoMittsure from '../MittsureLogo1.png';

const StyledDialogContent = styled(DialogContent)`
  padding: 16px;
`;

const StyledDialog = styled(Dialog)`
  // position: relative;
  // max-width: 700px;
`;  

const ModalHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
    `;
const isMobile = window.innerWidth < 900

const OrderLineItemModal = ({ onCancel, data, props, typeProp }) => {
  const [dataSet, setDataSet] = useState({});
  const [filteredData, setFilteredData] = useState({});
  const [seriesNames, setSeriesNames] = useState({})
  const [add, setAdd] = useState({})
   const [billAdd, setBillAdd] = useState({})
  const [loading, setLoading] = useState(false)
const [shippingDetails, setShippingDetails] = useState(null);
const [billingDetails, setBillingDetails] = useState(null);

  console.log(typeProp, "typeProptypeProptypeProptypeProp", billAdd, "<<<<<<<<<<<<   bill add", add, "<<<<<<<<<<<<   ship add",props, "propspropspropspropspropspropspropspropspropspropsprops")



  function selectAddress(value) {
    console.log(value, "valuieeeeeee");

    let s, st, d;

    try {
      s = JSON.parse(value.sAddress);
      st = JSON.parse(value.stAddress);
      d = JSON.parse(value.dAddress);
    } catch (error) {
      console.log("Error parsing address:", error);
      return;
    }

    if (d && Object.values(d).some(ele => ele)) {
      setAdd(d);
      console.log(d, "Selected Address: dAddress");
      return;
    }

    if (st && Object.values(st).some(ele => ele)) {
      setAdd(st);
      console.log(st, "Selected Address: stAddress");
      return;
    }

    if (s && Object.values(s).some(ele => ele)) {
      setAdd(s);
      console.log(s, "Selected Address: sAddress");
    }
  }

   function selectBillAddress(value) {
    console.log(value, "valuieeeeeee");

    let s, st, d;

    try {
      s = JSON.parse(value.sBillAddress);
      st = JSON.parse(value.stBillAddress);
      d = JSON.parse(value.dbillAddressData);
    } catch (error) {
      console.log("Error parsing address:", error);
      return;
    }

    if (d && Object.values(d).some(ele => ele)) {
      setBillAdd(d);
      console.log(d, "Selected Address: dAddress");
      return;
    }

    if (st && Object.values(st).some(ele => ele)) {
      setBillAdd(st);
      console.log(st, "Selected Address: stAddress");
      return;
    }

    if (s && Object.values(s).some(ele => ele)) {
      setAdd(s);
      setBillAdd(s);
      console.log(s, "Selected Address: sAddress");
    }
  }

  useEffect(() => {
    const obj = props?.find((item) => item.orderId === data.id);

    const groupedData = {};
    let a = {}
console.log(obj,"objobjobjobjobj")
    data.data.forEach(item => {
      a[item.series] = item.seriesName
      const seriesName = item.series ? item.series : '';
      if (!groupedData[seriesName]) {
        groupedData[seriesName] = [];
      }
      groupedData[seriesName].push(item);
    });
    setSeriesNames(a)
    setDataSet(obj);
    setFilteredData(groupedData);
    selectAddress(obj);
    selectBillAddress(obj)


    selectAddress(obj);
  selectBillAddress(obj);

  try {
    if (obj?.shippingDetails) {
      setShippingDetails(JSON.parse(obj.shippingDetails));
    }
    if (obj?.billingDetails) {
      setBillingDetails(JSON.parse(obj.billingDetails));
    }
  } catch (err) {
    console.log("Error parsing details:", err);
  }
  }, [])

  // function titleCase(value){
  //   let a=value.split("")
  //   a[0] = a[0].toUpperCase()
  //   return a.join("")
  // }

  function titleCase(value) {
    return value?.split(" ")
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  }

  const formatDateToIndian = (dateString) => {
    const date = new Date(dateString);

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = String(date.getFullYear());
    return `${day}-${month}-${year}`;
  };

  const formattedDate = formatDateToIndian(dataSet.createdAt);


  const sortedItems = (arr) => {
    arr.sort((a, b) => {
      return a?.sku_code?.localeCompare(b?.sku_code)
    })
    console.log(arr)
    return arr
  }
  const downloadInvoice = () => {
    setLoading(true);

    const date = new Date();
    const currentYear = date.getFullYear();
    const nextYear = (currentYear + 1).toString();
    const upcomingYear = nextYear.slice(-2);

const year = date.getFullYear();
const month = date.getMonth() + 1; 

let fyStartYear;
let fyEndYear;
console.log(year,"year")
if (month >= 4) {
  fyStartYear = year;
  fyEndYear = year + 1;
} else {
  fyStartYear = year - 1;
  fyEndYear = year;
}

const fiscalYearRange = `${fyStartYear}-${String(fyEndYear).slice(-2)}`;

    console.log(filteredData, "nainjiholf")
    const tableSections = Object.keys(filteredData).map(seriesName => {
      const name = seriesName || '';
      let totalQuantity = 0;
      const tableRows = sortedItems(filteredData[seriesName])?.map((item, ind) => {
        totalQuantity += item?.QTY || 0;
        return `
          <tr>
         <td style=" border-width: 0 1px 1px 1px; border-style: solid; border-color: #000; color:#000; text-align:left; width:5%; font-size:12px;">${ind + 1}</td>
            <td style="border-width: 0 1px 1px 0; border-style: solid; border-color: #000; color:#000; text-align:left;width: 10%; font-size:12px;">${item?.QTY || 0}</td>
            <td style="border-width: 0 1px 1px 0; border-style: solid; border-color: #000; color:#000; text-align:left;width: 13%; font-size:12px;">${item?.sku_code || 'N/A'}</td>
            <td style="border-width: 0 1px 1px 0; border-style: solid; border-color: #000; color:#000; text-align:left;width: 37%; font-size:12px;">${item?.nameSku || item?.product_name || 'N/A'}</td>
            <td style="border-width: 0 1px 1px 0; border-style: solid; border-color: #000; color:#000; text-align:left;width: 12%; font-size:12px;">${item?.className || 'N/A'}</td>
            <td style="border-width: 0 1px 1px 0; border-style: solid; border-color: #000; color:#000; text-align:left;width: 11%; font-size:12px;">${item?.Price || 0}</td>
            <td style="border-width: 0 1px 1px 0; border-style: solid; border-color: #000; color:#000; text-align:left;width: 17%; font-size:12px;">₹ ${item?.Price * item?.QTY || 0}</td>
          </tr>
        `}).join('');

      const totalSum = filteredData[seriesName]
        .reduce((sum, item) => sum + (item?.Price || 0) * (item?.QTY || 0), 0);
        // const totalSum1 = filteredData[!seriesName].map(item => item || "N/A")

        let objKey=Object.keys(filteredData)
        let k=objKey[0]
        // console.log(filteredData, "seriesNamesseriesNamesseriesNames",filteredData[k][0]?.productGroupName)

      return `
          <div class="table-section" style="margin-top: 20px; margin-left: 20px; margin-right: 20px;">
            <h4 style="text-align: left;"><b>${titleCase(seriesNames[name] || filteredData && filteredData[k][0]?.productGroupName)}</b></h4>
            <table style="width: 100%; border:1px solid #000" >
              <thead style="background-color: #f2f2f2; color: #000;">
                <tr style="background-color: #fff; color: #000;">
                  <th style="border-width: 1px 1px 1px 1px; border-style: solid; border-color: #000; width: 8%;text-align:left; background-color: #fff; color: #000; font-size:12px; font-weight:700;">S. No.</th>
                  <th style="border-width: 1px 1px 1px 0; border-style: solid; border-color: #000; width: 8%;text-align:left; background-color: #fff; color: #000;font-size:12px;  font-weight:700;">Qty.</th>
                  <th style="border-width: 1px 1px 1px 0; border-style: solid; border-color: #000; width: 19%;text-align:left; background-color: #fff; color: #000;font-size:12px;  font-weight:700;">SKU Codes</th>
                  <th style="border-width: 1px 1px 1px 0; border-style: solid; border-color: #000; width: 39%;text-align:left; background-color: #fff; color: #000;font-size:12px;  font-weight:700;">Title</th>
                  <th style="border-width: 1px 1px 1px 0; border-style: solid; border-color: #000; width: 12%;text-align:left; background-color: #fff; color: #000;font-size:12px;  font-weight:700;">Class</th>
                  <th style="border-width: 1px 1px 1px 0; border-style: solid; border-color: #000; width: 9%;text-align:left; background-color: #fff; color: #000;font-size:12px;  font-weight:700;">Rate</th>
                  <th style="border-width: 1px 1px 1px 0; border-style: solid; border-color: #000; width: 15%;text-align:left; background-color: #fff; color: #000;font-size:12px;  font-weight:700;">Amount</th>
                </tr>
              </thead>
              <tbody>
                ${tableRows}
              </tbody>
              <tfoot>
                <tr style="font-size:12px; font-weight:700">
                <td  style="border-width: 0 1px 1px 1px; border-style: solid; border-color: #000; color:#000;"><b>Total : </b></td>
                <td style="border-width: 0 1px 1px 0; border-style: solid; border-color: #000; color:#000;"><b>${totalQuantity}</b></td>
                <td colspan="2" style="border-width: 0 1px 1px 0; border-style: solid; border-color: #000; color:#000; "></td>
                  <td colspan="2" style="border-width: 0 1px 1px 0; border-style: solid; border-color: #000; color:#000; "><b>Sub Total:</b></td>
                  <td style="border-width: 0 1px 1px 0; border-style: solid; border-color: #000; color:#000; "><b>₹ ${totalSum}</b></td>
                </tr>
                <tr style="font-size:12px; font-weight:700">
                <td style=" border-width: 0 1px 1px 1px; border-style: solid; border-color: #000; color:#000;" colspan="4"></td>
                  <td style=" border-width: 0 1px 1px 0; border-style: solid; border-color: #000; color:#000;" colspan="2"><b>Discount:</b></td>
                  <td style=" border-width: 0 1px 1px 0; border-style: solid; border-color: #000; color:#000;"><b>${filteredData && filteredData[k][0]?.productGroupName == "MittPlus" ? "0" : typeProp === "specimen" ? 0 : dataSet.seriesDiscount ? JSON.parse(dataSet.seriesDiscount)[name] + "%" || 0 : 0}</b> </td>
                </tr>
                <tr style="font-size:12px; font-weight:700">
                <td style=" border-width: 0 1px 1px 1px; border-style: solid; border-color: #000; color:#000;" colspan="4"></td>
                  <td style=" border-width: 0 1px 1px 0; border-style: solid; border-color: #000; color:#000;" colspan="2"><b>Net Amount:</b></td>
                  <td style=" border-width: 0 1px 1px 0; border-style: solid; border-color: #000; color:#000;"><b>₹ ${typeProp === "specimen" ? 0 : (totalSum - (totalSum * (dataSet.seriesDiscount ? (JSON.parse(dataSet.seriesDiscount)[name] || 0) : 0) / 100)).toFixed(2)}</b> </td>
                </tr>
              </tfoot>
            </table>
          </div>
        `;
    }).join('');

    const htmlContent = `
        <div>
          <style>
            body {
              font-size: 15px;
              color: #000; 
            }
            h4, h5 {
              font-size: 16px;
               color: #000;
            }
            table {
              font-size: 15px;
              page-break-after: auto;
               color: #000;
            }
            .table-section {
              page-break-inside: auto;
  page-break-before: auto;
  page-break-after: auto;
            }
  tr {
  page-break-inside: avoid;
}

            .totals {
              text-align: right;
              margin-right: 20px;
              margin-top: 20px;
              font-weight:"800";
               color: #000;
            }
          </style>
          <div style="display: flex; justify-content: space-between; align-items: center; margin: 20px;">
            <div class="logo">
              <img src="${LogoMittsure}" alt="Logo" style="width: 150px; height: auto;" />
            </div>
            <div>
              <p style="color: #000;">Date: ${formattedDate}</p>
              <p style="color: #000;">SO #: ${dataSet.so_id || "N/A"}</p>
            </div>
          </div>
          <div class="main-heading" style="text-align: center; margin-top: 10px;">
            <h5 style="color: #000;"><b>MittSure Technologies LLP</b></h5>
            <h4 style="color: #000;"><b>${typeProp === "specimen" ? "SPECIMEN " : "SALES "}ORDER FORM - (${fiscalYearRange})</b></h4>
          </div>
          <div class="table-section" style="margin-top: 20px; margin-left: 20px; margin-right: 20px; margin-bottom:20px">
            <table style="width: 100%; border-collapse: collapse; border: 1px solid #000;">
              <tbody>
                <tr>
                <tr>
  <td style="border-width: 0 1px 1px 0; border-style: solid; border-color: #000;">
    <b>Bill To: - </b>
    ${billingDetails?.billingName || "N/A"} 
    ${billingDetails?.billingId ? `(${billingDetails.billingId})` : ""}<br/>
    ${billingDetails?.billingAddress || billAdd?.addressLine1 || "N/A"}
  </td>

  <td style="border-width: 0 0 1px 0; border-style: solid; border-color: #000;">
    <b>Ship To: - </b>
    ${shippingDetails?.shippingName || "N/A"} 
    ${shippingDetails?.shippingId ? `(${shippingDetails.shippingId})` : ""}<br/>
    ${shippingDetails?.shippingAddress || add?.addressLine1 || "N/A"}
  </td>
</tr>
                </tr>
                <tr>
                  <td style="color: #000; border-width: 0 1px 1px 0; border-style: solid; border-color: #000; color:#000;"><b>${"Party Name"}</b> ${dataSet?.schoolName ? dataSet?.schoolName + " - " + dataSet?.schoolId  : dataSet?.distributorNameforSchool + " - " + dataSet?.distributorIDforSchool || 'N/A'}</td>
                  <td style="color: #000;border-width: 0 0 1px 0; border-style: solid; border-color: #000; color:#000; "><b>State:</b> ${add?.state || 'N/A'}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td style="color: #000; border-width: 0 1px 1px 0; border-style: solid; border-color: #000; color:#000;"><b>Transport/Travels:</b> ${dataSet?.transporter_name || 'N/A'}</td>
                  <td style="color: #000; border-width: 0 0 1px 0; border-style: solid; border-color: #000; color:#000;"><b>Verification Code: - </b> ${dataSet && dataSet?.otp_need == "1" ? "Yes : " : "No" }   ${dataSet?.otp_need == "1" ? dataSet?.otpConsent : ""}</td>
                </tr>
                <tr>
                  <td style="color: #000;border-width: 0 1px 1px 0; border-style: solid; border-color: #000; color:#000; "><b>RM / ARM:</b> ${dataSet?.name || 'N/A'}</td>
                  <td style="color: #000;border-width: 0 0 1px 0; border-style: solid; border-color: #000; color:#000; "><b>RM / ARM Contact:</b> ${dataSet?.mobno || 'N/A'}</td>
                </tr>
                 <tr> 
                  <td style="color: #000;border-width: 0 1px 0 0; border-style: solid; border-color: #000; color:#000; "><b>Remark:</b> ${dataSet?.remark || 'None'}</td>
                  <td style="color: #000;border-width: 0 0 0 0; border-style: solid; border-color: #000; color:#000; "><b>Onboard for ERP:</b> ${dataSet?.onBoardERP == 1 || dataSet?.onBoardERP === '1' ? 'Yes' : 'No'}</td>
                </tr>
              </tfoot>
            </table>
          </div>
          <div style="text-align: left;display:flex; justify-content :start;">
            <h4 style="margin-left:13px;  color: #000;"><b>Admin Remark :-</b> ${dataSet?.updateRemark || "No Remark"}</h4>
          </div>
          <div style="text-align: left;display:flex; justify-content :start;">
            <h4 style="margin-left:13px;  color: #000;"><b>Order Remark :-</b> ${dataSet?.order_remark || "No Remark"}</h4>
          </div>

          ${tableSections}
          <div class="totals">
  <p class="text-dark" style="font-size:16px  color: #000;"> <b>Total:  ₹ ${dataSet.originalAmount || "N/A"}</b></p>
  <p class="text-dark" style="font-size:16px;  color: #000;"><b>Net to Pay:  ₹ ${dataSet.totalAmount || "N/A"}</b></p>
</div>

${typeProp === "specimen" ?"":
       ` <div style=" width: 100%; margin-top:30px">
          <h4 style="text-align: left;  color: #000;"><b>Add-On Products</b></h4>
          <table style="width: 100%; border-collapse: collapse; border: 0.5px solid #000;">
            <thead>
              <tr style="background-color: #f2f2f2;">
                <th style="padding: 8px; text-align: center; border-width: 1px 1px 1px 0; border-style: solid; border-color: #000; color:#000;  color: white; background-color: #fff; color: #000;">S. No.</th>
                <th style="padding: 8px; text-align: center; border-width: 1px 1px 1px 0; border-style: solid; border-color: #000; color:#000;  color: white; background-color: #fff; color: #000;">Name</th>
              </tr>
            </thead>
            <tbody>
              ${
                (() => {
                  const products = JSON.parse(dataSet.addOnProduct || '[]');
                  return products.length > 0
                    ? products
                      .map(
                        (product, ind) =>
                          `<tr>
                      <td style="padding: 8px; text-align: center; border-width: 0 1px 1px 0; border-style: solid; border-color: #000; color:#000;  color: #000;">${ind + 1}</td>
                      <td style="padding: 8px; text-align: center; border-width: 0 1px 1px 0; border-style: solid; border-color: #000; color:#000;  color: #000;">${product}</td>
                    </tr>`
                      )
                      .join('')
                    : `<tr>
                <td colspan="2" style="padding: 8px; text-align: center; border-width: 0 1px 1px 0; border-style: solid; border-color: #000; color:#000; font-weight: bold;  color: #000;">
                  No data available
                </td>
              </tr>`;
                })()
              }
            </tbody>
          </table>
        </div>`
      }
      `;

    const element = document.createElement('div');
    element.innerHTML = htmlContent;
    document.body.appendChild(element);

    const options = {
      margin: [0.5, 0.5, 0.5, 0.5],
      filename: 'Order_form.pdf',
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2, logging: true, dpi: 192, letterRendering: true },
      jsPDF: { unit: 'in', format: 'a3', orientation: 'portrait' }
    };
    html2pdf()
      .set(options)
      .from(element)
      .toPdf()
      .get('pdf')
      .then((pdf) => {
        setLoading(false);
        const totalPages = pdf.internal.getNumberOfPages();
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();

        for (let i = 1; i <= totalPages; i++) {
          pdf.setPage(i);
          pdf.setFontSize(10);
          pdf.setTextColor(0, 0, 0);

          pdf.text(
            `Page ${i} of ${totalPages}`,
            pageWidth - 1.5,
            pageHeight - 0.3
          );
        }
      })
      .save(dataSet?.so_id ? `${dataSet.so_id}.pdf` : 'Order_Form.pdf')
      .then(() => {
        document.body.removeChild(element);
      });

  };

  const getColumns = () => {
    let result = [
      {
        field: "itemName",
        headerName: "Item Name",
        sortable: false,
        width: 250,
        editable: false,
        renderCell: (params) => {
          let name = params.row?.nameSku || params.row?.product_name || "N/A";
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit">{name}</Typography>{console.log(params, "parammssss")}
            </Tooltip>
          )
        },
      },
      {
        field: "QTY",
        headerName: "Quantity",
        width: 120,
        sortable: false,
        renderCell: (params) => {
          let name = params.row.QTY || "N/A"
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit">{name}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "Price",
        headerName: "Unit Price",
        width: 120,
        sortable: false,
        renderCell: (params) => {
          let name = params.row.Price || 0;
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit">{name}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "Total",
        headerName: "Total Price",
        width: 150,
        sortable: false,
        renderCell: (params) => {
          let name = params.row?.Total || 0;
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit">{name}</Typography>
            </Tooltip>
          )
        },
      },
    ];
    return result
  }

  const renderContent = () => {
    return (
      <>
        <DataGrid
          className="payrollGrid"
          sx={{ height: isMobile ? "555px" : "500px" }}
          density="compact"
          rows={data.data}
          columns={getColumns()}
          rowHeight={60}
          disableSelectionOnClick
          disableRowSelectionOnClick
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 8,
              },
            },
          }}
          pageSizeOptions={[8]}
        />
        <Button variant="contained" color="primary"
          startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <DownloadIcon />}
          onClick={() => downloadInvoice()} sx={{ mt: 2, borderRadius: '10px' }}>
          {/* <DownloadIcon sx={{ mr: 1 }}  /> */}

          {/* Download Order Form */}
          {loading ? "Downloading..." : "Download Order Form"}
        </Button>
      </>
    );
  };

  return (
    <StyledDialog disableEnforceFocus maxWidth="lg" fullWidth={true} open={true} PaperProps={{
      style: {
        minHeight: !isMobile && 600, padding: "10px", borderRadius: "10px", minWidth: isMobile ? 350 : 750, width: isMobile ? 350 : 750
      },
    }}>
      <StyledDialogContent>
        <ModalHeaderContainer>
          <Typography variant="h5">Order Line Items {/*- <Tooltip title="Order Id">{"("+ data.id+")"}</Tooltip>*/}</Typography>
          <IconButton onClick={onCancel}>
            <CloseOutlined />
          </IconButton>
        </ModalHeaderContainer>
        {renderContent()}
      </StyledDialogContent>
    </StyledDialog>
  );
};

export default OrderLineItemModal;
